import React, {
  Component
} from 'react'
import {
  NavBar,
  List,
  Toast
} from 'antd-mobile'
import {
  ROOT_PATH
} from '../../config';
import axios from 'axios'
import Table from '../../components/Table'
import qs from 'qs';
import df from 'dateformat'
import {FARM_ORG, ORG_CODE, TOKEN} from '../../cache';
export default class NpDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gather: {},   // 页面下方的归总信息
      noData: false, // false 表示有数据。
      data2: [
        {
          'birthWeek': '',
          'aliveQty': 0,//活仔数
          'bornQty': 0,//分娩总数
          'crushQty': 0,//压死数
          'deadQty': 0,//死亡数
          'defQty': 0,//残疾数
          'litno1': '',//胎次
          'mummyQty': 0,//木乃伊
          'swineDateIn': '',//猪生成时间标识
          'swineTrack': '',//猪详情编码
          'transactionDate': '',//日期 2019-01-01
          'weakQty': 0//弱仔数
        }
      ],
      columns: [
        {
          id: 'col1',
          title: '', //表头信息
          fixed: true, //是否为固定表头
          width: 36, //设置固定宽度
          align: 'center', //文本对齐方式 left center right
          //定制该列数据的显示格式
          render(data, index) {
            return <span style={{ color: '#888' }}>{index + 1}</span>
          }
        },
        {
          id: 'col2',
          title: '日期',
          width: 105,
          align: 'center'
        },
        {
          id: 'col3',
          title: '出生周',
          width: 69,
          align: 'center'
        },
        {
          id: 'col4',
          width: 150,
          title: '母猪耳号',
          align: 'left',
          render(data) {
            const swineTrack = data && data.col4
            return <span>
              {swineTrack}
            </span>
          }
        },
        {
          id: 'col5',
          title: '胎次',
          width: 50,
          align: 'right'
        }
        ,
        {
          id: 'col6',
          title: '分娩总数',
          align: 'right'
        },
        {
          id: 'col7',
          title: '死亡总数',
          align: 'right'
        },
        {
          id: 'col8',
          title: '木乃伊',
          align: 'right'
        },
        {
          id: 'col9',
          title: '残疾',
          align: 'right'
        },
        {
          id: 'col10',
          title: '虚弱',
          align: 'right'
        },
        {
          id: 'col11',
          title: '压死',
          align: 'right'
        },
        {
          id: 'col12',
          title: '活仔猪',
          align: 'right'
        }
      ],
      details: []
    }
  }
  getDetail = (obj) => {
    let litno1 ='1'
    if (obj.col1 === '7胎以上') {
      litno1 = '8'
    } else {
      litno1 = obj.col1.split('胎')[0]
    }
    Toast.loading('加载中');
    axios.post(
      `${ROOT_PATH}/api/forward/ifarm/farrowNumberTableForLitno1`,
      qs.stringify({
        'startDate': df(this.props.start,'yyyy-mm-dd'),
        'endDate': df(this.props.end,'yyyy-mm-dd'),
        'gd_type': 'D001401',
        'gd_code': '2001',
        'litno1': litno1
      }),
      {
        headers: {
          'x-http-appid': '1',
          'x-http-device': '0',
          'Content-Type':'application/x-www-form-urlencoded',
          'Authorization': TOKEN,
          'farmorg': FARM_ORG,
          'orgcode': ORG_CODE
        }
      }
    )
      .then((res) => {
        Toast.hide();
        let data2 = res.data;
        let datas = [];
        data2.map((item,index) => {
          datas.push({
            col1: index,
            col2: item.transactionDate,
            col3: item.birthWeek || '',
            col4: item.swineTrack,
            col5: item.litno1,
            col6: item.bornQty,
            col7: item.deadQty,
            col8: item.mummyQty,
            col9: item.defQty,
            col10: item.weakQty,
            col11: item.crushQty,
            col12: item.aliveQty
          })
        });
        let gather = {};
  /*      'aliveQty': 0,//活仔数
          'bornQty': 0,//分娩总数
          'crushQty': 0,//压死数
          'deadQty': 0,//死亡数
          'defQty': 0,//残疾数
          'litno1': '',//胎次
          'mummyQty': 0,//木乃伊
          'swineDateIn': '',//猪生成时间标识
          'swineTrack': '',//猪详情编码
          'transactionDate': '',//日期 2019-01-01
          'weakQty': 0//弱仔数*/
        gather['产仔'] = res.data.reduce((t,o) => (t + o.bornQty || 0),0);
        gather['死胎'] = res.data.reduce((t,o) => (t + o.deadQty || 0),0);
        gather['木乃伊'] = res.data.reduce((t,o) => (t + o.mummyQty || 0),0);
        gather['畸形'] = res.data.reduce((t,o) => (t + o.defQty || 0),0);
        gather['弱仔'] = res.data.reduce((t,o) => (t + o.weakQty || 0),0);
        gather['压死'] = res.data.reduce((t,o) => (t + o.crushQty || 0),0);
        gather['活仔'] = res.data.reduce((t,o) => (t + o.aliveQty || 0),0);
        this.setState({details: datas,gather})
      })
      .catch((err) => {return err})
  };
  componentDidMount() {
    this.getDetail(this.props.data);
  }
  render() {
    const names = Object.keys(this.state.gather)
    const values = Object.values(this.state.gather)
    return (
      <React.Fragment>
        <NavBar mode="light">分胎次产仔性能详情</NavBar>
        <List renderFooter={() => ''}
            style={{height: document.documentElement.clientHeight - 45,overflowY:'scroll'}}
        >
          <Table columns={this.state.columns}
              data={this.state.details}
          />
          {/*胎次详情页面，下面增加一行合计信息(产仔、死胎、木乃伊、畸形、弱仔、压死、活仔)*/}

          {this.state.details.length > 0 && (<div>
            <List.Item>合计</List.Item>
            <div style={{display:'flex',background: '#F5F5F5',height: '44px',lineHeight: '44px',fontSize: '12px'}}>
              {
                names.map(n => <div key={n} style={{flex: 1}}>
                  {n}
                </div>)
              }
            </div>
            <div style={{display:'flex',height: '44px',lineHeight: '44px'}}>
              {
                values.map((v,key) => <div key={key} style={{flex: 1}}>
                  {v}
                </div>)
              }
            </div>
          </div>)
          }




          </List>

      </React.Fragment>
    )
  }
}
